import { ReactNode } from 'react';
import { ToastInput, ToastOptions, ToastSeverity, ToastState } from './toastTypes';

const SUCCESS_AUTO_HIDE_DURATION = 5000;

let toastCounter = 0;

const createToastId = () => {
  toastCounter += 1;
  return `toast-${Date.now()}-${toastCounter}`;
};

export const createToast = (toastInput: ToastInput, severity: ToastSeverity = 'info'): ToastState => {
  const options: ToastOptions =
    typeof toastInput === 'object' && toastInput !== null && 'message' in toastInput
      ? toastInput
      : { message: toastInput };

  const toastSeverity = options.severity || severity;

  return {
    id: options.id || createToastId(),
    message: options.message,
    title: options.title,
    severity: toastSeverity,
    autoHideDuration: toastSeverity === 'success' ? SUCCESS_AUTO_HIDE_DURATION : null,
    action: options.action,
    onClose: options.onClose,
    createdAt: Date.now(),
  };
};

type ToastShortcutOptions = Omit<ToastOptions, 'message' | 'severity'>;

export const createSuccessToast = (message: ReactNode, options?: ToastShortcutOptions) =>
  createToast({ ...options, message, severity: 'success' });

export const createErrorToast = (message: ReactNode, options?: ToastShortcutOptions) =>
  createToast({ ...options, message, severity: 'error' });

export const createWarningToast = (message: ReactNode, options?: ToastShortcutOptions) =>
  createToast({ ...options, message, severity: 'warning' });

export const createInfoToast = (message: ReactNode, options?: ToastShortcutOptions) =>
  createToast({ ...options, message, severity: 'info' });
